import { Identify } from '@amplitude/analytics-browser';
import { GlobalState } from '@leverege/ui-redux';
export default {
  id: 'molten.AmplitudeRolesPlugin',
  onLoggedIn: (molten, action) => {
    molten.addPlugin('AmplitudePlugin', {
      init() {
        return {
          setup(config, amplitude) {
            try {
              const state = GlobalState.get();
              const roles = state?.ui?.personas || [];
              if (!roles.length) {
                console.warn('No roles found in GlobalState');
                return;
              }
              const id = new Identify();
              roles.forEach((role, index) => {
                if (role && role.name) {
                  id.setOnce(`role_${role.name}`, true);
                }
              });
              amplitude.identify(id);
            } catch (error) {
              console.error('Error in AmplitudeRolesPlugin:', error);
            }
          }
        };
      }
    });
  }
};